import React from "react";
import styles from "./loader.module.css";


function Loader() {

  return (
    <div className={styles.container}>
      <span className={styles.loader}/>
    </div>
  );
}

export default Loader;
